<template>
  <b-button
    :variant="variant"
    v-if="isValidPermission(apiCode)"
    :class="{ 'd-none': !isValidPermission(apiCode) }"
    :style="style"
    :disabled="disabled"
    v-on="$listeners"
  >
    <slot></slot>
  </b-button>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PermissionButton",
  props: {
    apiCode: {
      type: String,
      default: "",
    },
    variant: {
      type: String,
      default: "primary",
    },
  
    disabled: {
      type: Boolean,
      default: false,
    },
    // Add any other props you want here
  },
});
</script>
